import React, { useState, useRef } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";

const MapAddress = () => {
  const [address, setAddress] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const debounceTimeout = useRef(null);

  // Fetch nearby places using the input address
  const fetchNearbyPlaces = async (query) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${query}&limit=10`
      );
      const data = await response.json();
      const places = data.map((place) => place.display_name);
      setSuggestions(places);
    } catch (err) {
      setError("Error fetching nearby places.");
    }

    setLoading(false);
  };

  // Debounce function to handle input changes
  const handleAddressChange = (event, newValue) => {
    setAddress(newValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    if (newValue?.length >= 3) {
      debounceTimeout.current = setTimeout(() => {
        fetchNearbyPlaces(newValue);
      }, 500);
    } else {
      setSuggestions([]);
    }
  };

  return (
    <div className="mb-4">
      <Autocomplete
        freeSolo
        options={suggestions}
        value={address}
        onChange={(event, newValue) => setAddress(newValue)}
        onInputChange={handleAddressChange}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Address"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default MapAddress;
